import { unstable_HistoryRouter } from 'react-router-dom';

const CustomRouter = unstable_HistoryRouter;
CustomRouter.displayName = 'CustomRouter';

export default CustomRouter;
